import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { Logger } from './logger.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  private readonly log = new Logger('AuthGuardService');

  async canActivate(): Promise<boolean> {
    const token = await this.authService
      .getAccessToken$()
      .pipe(take(1))
      .toPromise();
    if (token) {
      this.log.debug(`allow`);
      return true;
    } else {
      this.log.debug(`deny`);
      this.router.navigate(['/auth']);
      return false;
    }
  }
}
